import type { UserRole } from '@hotel-manager/shared-types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// HM-384 cluster login PIN: store ora include campi PIN (username/display/initials)
// e persiste su localStorage cosi' la sidebar si renderizza subito al refresh
// senza aspettare /auth/me. La sessione "verita'" pero' rimane il cookie
// HttpOnly hm_access: lo store e' solo cache UI, validato dal boot via /auth/me.
export type AuthUser = {
  id: string;
  email: string;
  role: UserRole;
  tenantId: string;
  // Optional/nullable: account legacy email+password li riceve come null/undefined
  // dal backend; lo store normalizza a null su setUser tramite spread compatibile.
  username?: string | null;
  displayName?: string | null;
  initials?: string | null;
};

type AuthState = {
  user: AuthUser | null;
  isHydrated: boolean;
  setUser: (user: AuthUser | null) => void;
  logout: () => void;
  setHydrated: (h: boolean) => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isHydrated: false,
      setUser: (user) => set({ user }),
      logout: () => set({ user: null }),
      setHydrated: (h) => set({ isHydrated: h }),
    }),
    {
      name: 'hm-auth-cache',
      // Persistiamo SOLO user (no isHydrated, e' state runtime).
      partialize: (s) => ({ user: s.user }),
    },
  ),
);
